import React from "react";
import ExpertiseCard from "./ExpertiseCard";
import { Box } from "@mui/material";
import ExpertiseCardImage01 from "../../assets/images/Expertise01Image.png";
import ExpertiseCardImage02 from "../../assets/images/Expertise02Image.png";
import ExpertiseCardImage03 from "../../assets/images/Expertise03Image.png";
import ExpertiseCardImage04 from "../../assets/images/Expertise04Image.png";
import ExpertiseCardImage05 from "../../assets/images/Expertise05Image.png";
import ExpertiseCardImage06 from "../../assets/images/Expertise06Image.png";
import ExpertiseCardImage07 from "../../assets/images/Expertise07Image.png";
import ExpertiseCardImage08 from "../../assets/images/Expertise08Image.png";
import image1 from "../../assets/icons/Whatweoffer01.png";
import image2 from "../../assets/icons/Whatweoffer02.png";
import image3 from "../../assets/icons/Whatweoffer03.png";
import image4 from "../../assets/icons/Whatweoffer04.png";
import image5 from "../../assets/icons/Whatweoffer05.png";
import image6 from "../../assets/icons/Whatweoffer06.png";
import image7 from "../../assets/icons/Whatweoffer07.png";
import image8 from "../../assets/icons/Whatweoffer08.png";

const expertisedata = [
  {
    id: 1,
    title: "Brand & Communication Strategy",
    description:
      "Inteliphyle has a deep expertise in helping clients refine their brand identity, craft clear messaging, align communications with target audiences, enhance visibility, and build consistent, impactful strategies to achieve their business objectives.",
    image: ExpertiseCardImage01,
    icon: image1,
  },
  {
    id: 2,
    title: "Market Entry Strategy",
    description:
      "We assist clients in market entry by analyzing opportunities, identifying target audiences, assessing competitors, tailoring strategies, assessing size of prize, positioning, optimizing pricing, and determining distribution channels for successful expansion.",
    image: ExpertiseCardImage02,
    icon: image2,
  },
  {
    id: 3,
    title: "Innovation opportunites",
    description:
      "With the extensive and rich innovation consulting experience within the Inteliphyle team, we can help clients identify white spaces by analyzing market gaps, emerging trends, and unmet needs, fostering innovation through ideation and strategic planning to create unique, competitive growth opportunities for them.",
    image: ExpertiseCardImage03,
    icon: image3,
  },
  {
    id: 4,
    title: "Social Media Analytics",
    description:
      "We can leverage social media analytics to track performance, analyze audience behavior, measure engagement, identify trends, refine strategies, and optimize content for improved brand visibility and ROI.",
    image: ExpertiseCardImage04,
    icon: image4,
  },
  {
    id: 5,
    title: "Emerging Trends Identification",
    description:
      "Inteliphyle identifies emerging trends through a mix of primary and secondary research, data analysis, and industry insights, thereby enabling clients to anticipate shifts, innovate solutions, and strategically position themselves for sustainable future growth.",
    image: ExpertiseCardImage05,
    icon: image5,
  },
  {
    id: 6,
    title: "Predictive Growth Modelling",
    description:
      "Inteliphyle uses predictive modeling to analyze data, uncover growth drivers, forecast trends, and optimize strategies.  Through predictive growth modeling, we empower brands to make data-driven decisions for maximizing performance and long-term success.",
    image: ExpertiseCardImage06,
    icon: image6,
  },
  {
    id: 7,
    title: "Retail Analytics",
    description:
      "We utilize retail analytics to assess sales data, optimize inventory, identify high-performing locations, enhance customer targeting, refine pricing strategies, and streamline distribution for both offline and online channels - driving increased sales and market reach.",
    image: ExpertiseCardImage07,
    icon: image7,
  },
  {
    id: 8,
    title: "Go-To-Market Strategy",
    description:
      "Inteliphyle crafts Go-To-Market strategies for clients by analyzing target audiences, optimizing product positioning, aligning messaging, integrating offline and online channels, and streamlining execution to maximize reach, engagement, and revenue.",
    image: ExpertiseCardImage08,
    icon: image8,
  },
];

const ExpertiseCardSection = ({ CardImage01 }) => {
  return (
    <Box
      sx={{
        backgroundColor: "#ecebeb",
        display: "flex",
        flexDirection: "column",
        gap: { xs: "1.5rem", sm: "0rem" },
        marginTop: { xs: "1rem", md: "2rem" },
        paddingBottom: "2rem",
      }}
    >
      {expertisedata.map((expertisedatas) => (
        <ExpertiseCard
          icon={expertisedatas.icon}
          title={expertisedatas.title}
          description={expertisedatas.description}
          CardImage01={expertisedatas.image}
        />
      ))}

      {/* <ExpertiseCard title="Market Entry Strategy" CardImage01={CardImage01} />
      <ExpertiseCard
        title="Innovation opportunites"
        CardImage01={CardImage01}
      />
      <ExpertiseCard title="Social Media Analytics" CardImage01={CardImage01} />
      <ExpertiseCard
        title="Emerging Trends Identification"
        CardImage01={CardImage01}
      />
      <ExpertiseCard
        title="Predictive Growth Modelling"
        CardImage01={CardImage01}
      />
      <ExpertiseCard title="Retail Analytics" CardImage01={CardImage01} />
      <ExpertiseCard title="Go to Market Strategy" CardImage01={CardImage01} /> */}
    </Box>
  );
};

export default ExpertiseCardSection;
